<script setup>
import ImageLinkCard from '@/components/landing/ImageLinkCard.vue';
import alarmPartner from '@/assets/ALARM-Partner.png';
import awareness from '@/assets/Foto-Awarenes-Forum.png';
import germanMap from '@/assets/German_Map_DE.png';
import resolveImgUrl from '@/services/resolveImageUrl.js';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const LS2 = resolveImgUrl('LS2.png', locale.value);
</script>

<template>
  <div class="bg-softBlue text-basecolor py-8 md:py-24 sm:px-2 lg:px-4">
    <div class="mx-auto max-w-7xl px-6">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <h2 class="text-3xl font-bold tracking-tight">
          {{ $t('landingPage.alarmSection.title') }}
        </h2>
        <p class="mt-12 text-md">
          {{ $t('landingPage.alarmSection.text') }}
        </p>
      </div>
      <div class="isolate mx-auto mt-12 grid max-w-md grid-cols-1 justify-items-center gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4">
        <ImageLinkCard
          :img-src="alarmPartner"
          :title="$t('landingPage.alarmSection.alarmProject.title')"
          :text="$t('landingPage.alarmSection.alarmProject.text')"
          :button-text="$t('landingPage.alarmSection.seeMore')"
          button-link="https://alarm.wildau.biz/en/"
        />
        <ImageLinkCard
          :img-src="LS2"
          :title="$t('landingPage.alarmSection.digital.title')"
          :text="$t('landingPage.alarmSection.digital.text')"
          :button-text="$t('landingPage.alarmSection.seeMore')"
          button-link="https://alarm.wildau.biz/#learningScenarios"
        />
        <ImageLinkCard
          :img-src="germanMap"
          :title="$t('landingPage.alarmSection.partners.title')"
          :text="$t('landingPage.alarmSection.partners.text')"
          :button-text="$t('landingPage.alarmSection.seeMore')"
          button-link="https://alarm.wildau.biz/#partner"
        />
        <ImageLinkCard
          :img-src="awareness"
          :title="$t('landingPage.alarmSection.publication.title')"
          :text="$t('landingPage.alarmSection.publication.text')"
          :button-text="$t('landingPage.alarmSection.seeMore')"
          button-link="https://alarm.wildau.biz/en/#publications"
        />
      </div>
    </div>
  </div>
</template>
